import {
  USER_ROLES,
  EVOKE_ROLES,
  CLINIC_ROLES,
  EVOKE_ACTIVE,
  CLINIC_ACTIVE,
  EVOKE_PROCESSED,
  CLINIC_PROCESSED,
} from "static/constants";

// Only these roles can unprocess from Signed/Archived
const CLINIC_PROCESSED_ROLES = [
  USER_ROLES.ADMIN,
  USER_ROLES.USER,
  USER_ROLES.CLINIC_ADMIN,
  USER_ROLES.PHYSICIAN,
];

export const isReportSigned = (report) =>
  Boolean(report?.eSig && report?.signedBy?.name);

export const isConnectivityReport = (report) =>
  report?.transmissionType === "connectivityStatus";

export const getFooterView = ({
  role,
  report,
  reportState,
  isArchiveReport,
}) => {
  const isEvokeUser = EVOKE_ROLES.includes(role);
  const isClinicUser = CLINIC_ROLES.includes(role);

  const isReadOnly =
    (!isEvokeUser && !isClinicUser) ||
    role === USER_ROLES.ASSISTANT ||
    !reportState ||
    !report?._id ||
    report.legacy ||
    report.locked ||
    isArchiveReport;

  if (isReadOnly) return null;

  if (
    reportState === CLINIC_PROCESSED &&
    !CLINIC_PROCESSED_ROLES.includes(role)
  ) {
    return null;
  }

  const view = getReportActionView({ reportState, role });

  // Connectivity reports only get the Process button in Clinic Active
  if (isConnectivityReport(report) && view !== CLINIC_ACTIVE) return null;

  if (isEvokeUser) return view;

  return [EVOKE_ACTIVE, EVOKE_PROCESSED].includes(view) ? null : view;
};

export const getReportActionView = ({ reportState, role }) =>
  EVOKE_ROLES.includes(role) && reportState && reportState !== EVOKE_ACTIVE
    ? EVOKE_PROCESSED
    : reportState;
